import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatCurrency, formatDate } from '@/utils/formatters';
import { DEFAULT_CATEGORIES } from '@/constants';

const CAT_MAP = Object.fromEntries(DEFAULT_CATEGORIES.map(c => [c.id, c]));

function TransactionItem({ expense }) {
  const cat = CAT_MAP[expense.category];
  return (
    <div className="flex items-center gap-3 py-2 border-b border-gray-50 last:border-0">
      <div
        className="w-9 h-9 rounded-lg flex items-center justify-center text-base flex-shrink-0"
        style={{ background: cat ? `${cat.color}22` : '#f0f0f0' }}
        aria-hidden
      >
        {cat?.emoji ?? '🔖'}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-800 truncate">{expense.vendor}</p>
        <p className="text-xs text-gray-400 mt-0.5">
          {formatDate(expense.date)} · {cat?.label ?? expense.category} · {expense.paymentMode}
        </p>
      </div>
      <span className="text-sm font-bold text-primary flex-shrink-0">
        {formatCurrency(expense.amount)}
      </span>
    </div>
  );
}

export default function RecentTransactions({ expenses = [] }) {
  const navigate = useNavigate();
  const recent = expenses.slice(0, 10);

  return (
    <div className="mx-3 mb-4">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-xs font-bold uppercase tracking-wide text-gray-600">
          Recent Transactions
        </h3>
        <button
          className="text-xs text-primary font-medium"
          onClick={() => navigate('/expenses')}
        >
          View all →
        </button>
      </div>
      <div className="card">
        {recent.length ? (
          recent.map(e => <TransactionItem key={e.id} expense={e} />)
        ) : (
          <p className="text-sm text-gray-400 text-center py-4">No transactions yet</p>
        )}
      </div>
    </div>
  );
}
